/* eslint-disable no-restricted-syntax */
/* eslint-disable no-param-reassign */
// Minimal extracted matching logic from mark.js without DOM interaction
import React from 'react';

function escapeStr(str) {
  // eslint-disable-next-line no-useless-escape
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}

function getSeparatedKeywords(sv, separateWordSearch = true) {
  const stack = [];
  sv.forEach((kw) => {
    if (!separateWordSearch) {
      if (kw.trim() && stack.indexOf(kw) === -1) {
        stack.push(kw);
      }
    } else {
      kw.split(' ').forEach((kwSplitted) => {
        if (kwSplitted.trim() && stack.indexOf(kwSplitted) === -1) {
          stack.push(kwSplitted);
        }
      });
    }
  });
  return {
    keywords: stack.sort((a, b) => b.length - a.length),
    length: stack.length,
  };
}

export function createRegExp(str, opt = {}) {
  str = escapeStr(str);
  if (opt.diacritics) {
    // Ersetze deutsche Umlaute und ähnliche Zeichen durch Regex-Gruppen
    str = str
      .replace(/a/g, '[aäáàâãåā]')
      .replace(/A/g, '[AÄÁÀÂÃÅĀ]')
      .replace(/o/g, '[oöóòôõøō]')
      .replace(/O/g, '[OÖÓÒÔÕØŌ]')
      .replace(/u/g, '[uüúùûū]')
      .replace(/U/g, '[UÜÚÙÛŪ]')
      .replace(/s/g, '[sßśš]')
      .replace(/S/g, '[SŚŠ]')
      .replace(/e/g, '[eéèêëēę]')
      .replace(/E/g, '[EÉÈÊËĒĘ]')
      .replace(/i/g, '[iíìîïīį]')
      .replace(/I/g, '[IÍÌÎÏĪĮ]')
      .replace(/c/g, '[cçćč]')
      .replace(/C/g, '[CÇĆČ]')
      .replace(/n/g, '[nñńň]')
      .replace(/N/g, '[NÑŃŇ]');
  }
  // Genauigkeit: "partially" = überall im Wort
  return str;
}

// Gibt true zurück, wenn ein Match gefunden wurde
export function textMatches(text, search, options = {}) {
  const { keywords } = getSeparatedKeywords(
    Array.isArray(search) ? search : [search],
    options.separateWordSearch !== false
  );
  const caseSensitive = !!options.caseSensitive;
  return keywords.some((kw) => {
    const pattern = createRegExp(kw, options);
    const flags = caseSensitive ? 'g' : 'gi';
    const re = new RegExp(pattern, flags);
    return re.test(text);
  });
}

// Sucht im Array mit Objekten in mehreren Properties eines Objekts und markiert Treffer mit <mark>
export function searchAndMarkInArrayOfObjects(
  arr,
  search,
  properties = [],
  options = {}
) {
  const { keywords } = getSeparatedKeywords(
    Array.isArray(search) ? search : [search],
    options.separateWordSearch !== false
  );
  const caseSensitive = !!options.caseSensitive;
  const flags = caseSensitive ? 'g' : 'gi';

  return arr
    .map((obj) => {
      let found = false;
      const newObj = { ...obj };
      properties.forEach((prop) => {
        if (typeof obj[prop] === 'string') {
          let marked = obj[prop];
          // Collect all match ranges for all keywords
          const matchRanges = [];
          keywords.forEach((kw) => {
            const pattern = createRegExp(kw, options);
            const re = new RegExp(pattern, flags);
            let match = re.exec(marked);
            while (match !== null) {
              matchRanges.push({
                start: match.index,
                end: match.index + match[0].length,
              });
              // Prevent infinite loop for zero-length matches
              if (re.lastIndex === match.index) {
                re.lastIndex = match.index + 1;
              }
              match = re.exec(marked);
            }
          });
          // Merge overlapping/adjacent ranges
          const merged = [];
          for (const range of matchRanges) {
            if (!merged.length || merged[merged.length - 1].end < range.start) {
              merged.push({ ...range });
            } else {
              merged[merged.length - 1].end = Math.max(
                merged[merged.length - 1].end,
                range.end
              );
            }
          }
          if (merged.length > 0) found = true;
          // Insert <mark> tags from end to start
          let i = merged.length - 1;
          while (i >= 0) {
            const { start, end } = merged[i];
            marked = `${marked.slice(
              0,
              start
            )}<mark class="text-highlight" data-markjs='true'>${marked.slice(
              start,
              end
            )}</mark>${marked.slice(end)}`;
            i -= 1;
          }
          newObj[prop] = marked;
        }
      });
      return found ? newObj : null;
    })
    .filter(Boolean);
}

export default textMatches;
